export const THEME_PREFERENCE_KEY = 'mouse-driver.uiTheme';
export const DEFAULT_THEME = 'theme1';

const THEMES = new Set(['theme1', 'theme2']);

export const normalizeThemePreference = (value) =>
  THEMES.has(value) ? value : DEFAULT_THEME;

export const readThemePreference = () => {
  try {
    return normalizeThemePreference(
      window.localStorage.getItem(THEME_PREFERENCE_KEY)
    );
  } catch {
    return DEFAULT_THEME;
  }
};

export const writeThemePreference = (value) => {
  const normalized = normalizeThemePreference(value);
  try {
    window.localStorage.setItem(THEME_PREFERENCE_KEY, normalized);
  } catch {
    // localStorage 不可用时，当前 React 会话仍然可以切换主题。
  }
  return normalized;
};
